import * as api from "@/api/company";
import { useQuery } from "react-query";

export function useQualifierCompanyList() {
  const queryKey = ["companies", "qualifier"];
  return useQuery(queryKey, api.getCompaniesFromQualifier);
}

export function useCoordinatorCompanyList() {
  const queryKey = ["companies", "coordinator"];
  return useQuery(queryKey, api.getCompaniesFromCoordinator);
}

export function useQualifierDivisions(companyId?: string) {
  const id = companyId ?? "";
  const queryKey = ["companies", "qualifier", "divisions", id];
  return useQuery(queryKey, () => api.getDivisionsFromQualifier(id), {
    enabled: Boolean(companyId),
  });
}
